import { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";

import { SmoothScroll, scrollToTop } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AskExpertDialog } from "@/components/AskExpertDialog";
import { UIProvider } from "@/context/UIContext";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Story from "@/pages/Story";
import Safety from "@/pages/Safety";
import Contact from "@/pages/Contact";

const Page = ({ children }) => (
  <motion.main
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.main>
);

const AnimatedRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    scrollToTop(true);
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Page><Home /></Page>} />
        <Route path="/services" element={<Page><Services /></Page>} />
        <Route path="/story" element={<Page><Story /></Page>} />
        <Route path="/safety" element={<Page><Safety /></Page>} />
        <Route path="/contact" element={<Page><Contact /></Page>} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <div className="App">
      <UIProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Navbar />
            <AnimatedRoutes />
            <Footer />
            <AskExpertDialog />
            <Toaster
              position="top-center"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#171717",
                  border: "1px solid rgba(201,160,53,0.4)",
                  color: "#F2F2F2",
                  borderRadius: "0px",
                },
              }}
            />
          </SmoothScroll>
        </BrowserRouter>
      </UIProvider>
    </div>
  );
}

export default App;
